import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { Button, Clickable } from '@fashionnovateam/nova-ui-toolkit';

import {
  useBrowserPrint,
  BrowserPrintConfig,
} from '../../../../Lib/Hooks/browserPrint.hooks';

import styles from './PrinterConfigurationSelect.module.css';
import { PrinterType } from '../types';

interface PrinterConfigurationSelectProps {
  printerType: PrinterType;
  onBackClick: () => void;
  onContinueClick: (config: BrowserPrintConfig) => void;
}

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& button': {
      flexBasis: '20%',
      margin: '2%',
    },
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    marginTop: '5%',
    marginBottom: '7%',
    width: '100%',
  },
}));

function PrinterConfigurationSelect({
  printerType,
  onBackClick,
  onContinueClick,
}: PrinterConfigurationSelectProps) {
  const { classes } = useStyles();
  const { deviceList, loading } = useBrowserPrint();
  const [currenltySelectedDevice, setCurrenltySelectedDevice] =
    useState<BrowserPrintConfig | null>(null);

  const handleChange = (event: SelectChangeEvent<string>) => {
    if (loading) return;
    const deviceId = event.target.value;
    const deviceConfig = deviceList?.find(
      (device: BrowserPrintConfig) =>
        `${device.name}-${device.uid}` === deviceId,
    );

    const newConfig = deviceConfig as BrowserPrintConfig;
    const newConfigFormatted = {
      name: newConfig.name,
      connection: newConfig.connection,
      deviceType: newConfig.deviceType,
      manufacturer: newConfig.manufacturer,
      provider: newConfig.provider,
      uid: newConfig.uid,
    };
    setCurrenltySelectedDevice(newConfigFormatted);
  };

  const handleContinueClick = () => {
    if (currenltySelectedDevice) {
      onContinueClick(currenltySelectedDevice);
    }
  };

  const printerLabel: Record<PrinterType, string> = {
    unitLabel: 'UNIT LABEL PRINTER',
    hangTag: 'HANGTAG PRINTER',
    cartonLabel: 'CARTON LABEL PRINTER',
  };

  return (
    <div>
      <div className="flex items-center">
        <Clickable onClick={onBackClick}>
          <KeyboardArrowLeft className="mr-4" />
        </Clickable>
        <span className={styles.printerConfigTitle}>
          CONFIGURE {printerLabel[printerType]}{' '}
        </span>
      </div>
      <FormControl className={classes.formControl}>
        <Select
          value={
            currenltySelectedDevice
              ? `${currenltySelectedDevice.name}-${currenltySelectedDevice.uid}`
              : ''
          }
          onChange={handleChange}
        >
          {!loading &&
            deviceList?.map((device) => (
              <MenuItem
                value={`${device.name}-${device.uid}`}
                key={`${device.name}-${device.uid}`}
              >
                {device.name || device.uid}
              </MenuItem>
            ))}
          {loading && <MenuItem value="">Loading...</MenuItem>}
        </Select>
      </FormControl>
      <Button onClick={handleContinueClick}>Continue</Button>
    </div>
  );
}

export default PrinterConfigurationSelect;
